import i18n from "i18next";

import type { Profession } from "api/schemas/shared";

export function translateProfession(profession: Profession): string {
  const keyMap: Record<Profession, string> = {
    occupational_therapist: i18n.t("settings.profile_information.profession.occupational_therapist"),
    physical_therapist_assistant: i18n.t("settings.profile_information.profession.physical_therapist_assistant"),
    physical_therapist: i18n.t("settings.profile_information.profession.physical_therapist"),
    speech_therapist: i18n.t("settings.profile_information.profession.speech_therapist"),
    wellness_therapist: i18n.t("settings.profile_information.profession.wellness_therapist"),
  };

  return keyMap[profession] || profession;
}
